import { render, staticRenderFns } from "./list.vue?vue&type=template&id=8704135a&scoped=true&"
import script from "./list.vue?vue&type=script&lang=ts&"
export * from "./list.vue?vue&type=script&lang=ts&"
import style0 from "./list.vue?vue&type=style&index=0&id=8704135a&scoped=true&lang=scss&"
import style1 from "./list.vue?vue&type=style&index=1&id=8704135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8704135a",
  null
  
)

export default component.exports